export default "__VITE_ASSET__BLSIO$$R__"